/**
 * remote_audio_registry — 차량→콕핏 수신 오디오 스트림의 "최신 값" 보관소.
 *
 * 타이밍 버그 수정: WebRTC `onTrack` 은 앱 루트(useRemoteMediaTracks)에서 등록되는데,
 * `#remote-audio` 엘리먼트는 lazy 한 SceneInterpreter→Communicator 안에 있다. 첫 연결에서는
 * onTrack 이 엘리먼트 마운트보다 먼저 발화해 attachMediaStream 이 "element not found" 로
 * 조용히 실패 → 스피커 무음. (시그널링이 끊겼다 복구되는 경로에서는 엘리먼트가 이미 떠 있어
 * 동작했다 — 사용자가 보고한 "복구하면 스피커가 됨".)
 *
 * 해결: onTrack 이 오디오를 라우팅할 때 스트림을 여기에 저장한다. Communicator 의 워치독은
 * 엘리먼트가 마운트된 뒤 srcObject 가 비어 있으면 이 보관소에서 가져와 붙인다 → 양방향
 * 마운트 순서에 안전. 의존성이 없는 경량 모듈이라 어디서든 import 가능.
 */

let pendingStream: MediaStream | null = null;

export function setPendingRemoteAudioStream(stream: MediaStream | null): void {
  pendingStream = stream;
}

export function getPendingRemoteAudioStream(): MediaStream | null {
  return pendingStream;
}

export function clearPendingRemoteAudioStream(): void {
  pendingStream = null;
}

/** 스트림에 살아있는(live) 오디오 트랙이 있는지. */
export function streamHasLiveAudio(stream: MediaStream | null): boolean {
  if (
    !stream ||
    typeof MediaStream === "undefined" ||
    !(stream instanceof MediaStream)
  ) {
    return false;
  }
  return stream.getAudioTracks().some((track) => track.readyState === "live");
}
